import React from "react";

/*
  A deliberately tiny inline notation for editable prose: **bold** and
  _italic_, nothing else.

  Content lines are stored as plain text so they stay readable and editable in
  the back room, but the essay leans on emphasis often enough that stripping it
  would flatten the writing. Anything that isn't one of the two markers is
  rendered verbatim, so a stray asterisk can never break a paragraph.
*/
const TOKEN = /(\*\*[^*]+\*\*|_[^_]+_)/g;

export function inline(text) {
  if (typeof text !== "string" || !text) return text || null;
  const parts = text.split(TOKEN).filter((p) => p !== "");
  if (parts.length === 1) return text;

  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**") && part.length > 4) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith("_") && part.endsWith("_") && part.length > 2) {
      return <em key={i}>{part.slice(1, -1)}</em>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}

export default inline;
